// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimSearchModel {
    static getAttributeTypeMap() {
        return ClaimSearchModel.attributeTypeMap;
    }
}
ClaimSearchModel.discriminator = undefined;
ClaimSearchModel.additionalProperties = false;
ClaimSearchModel.attributeTypeMap = [
    {
        "name": "ids",
        "baseName": "ids",
        "type": ""
    },
    {
        "name": "claimGroupIds",
        "baseName": "claimGroupIds",
        "type": ""
    },
    {
        "name": "parentClaimIds",
        "baseName": "parentClaimIds",
        "type": ""
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": ""
    },
    {
        "name": "claimStatusIds",
        "baseName": "claimStatusIds",
        "type": ""
    },
    {
        "name": "paymentTypeIds",
        "baseName": "paymentTypeIds",
        "type": ""
    },
    {
        "name": "externalReferences",
        "baseName": "externalReferences",
        "type": ""
    },
    {
        "name": "isInPaymentBatch",
        "baseName": "isInPaymentBatch",
        "type": "boolean"
    },
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "requestedPaymentTypeId",
        "baseName": "requestedPaymentTypeId",
        "type": "number"
    },
    {
        "name": "processorId",
        "baseName": "processorId",
        "type": "number"
    },
    {
        "name": "conditionTypeId",
        "baseName": "conditionTypeId",
        "type": "number"
    },
    {
        "name": "conditionIsOpen",
        "baseName": "conditionIsOpen",
        "type": "boolean"
    },
];
//# sourceMappingURL=claimSearchModel.js.map